import * as React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { Textbox } from '../inputs/textbox';
import { PrimaryButton } from '../buttons/primary-button';
import { bindActionCreators } from 'redux';
import { IAutocompleteResults } from '../../DTO/search';
import { Autocomplete } from './autocomplete';
import { SearchSuggestion } from './search-suggestion';
import { IDropdownSelectProps } from '../inputs/dropdown';

interface IProps {
    id: string;
    onSearch: (val: string) => void;
    onChange: (val: string, setAutocompleteResults?: (hits: string[]) => void) => void;
    searchButtonText?: string;
    placeHolder?: string;
    charsForAutocomplete?: number;
    searchText: string;
    searchSuggestionText: string;
    searchSuggestion: string;
    loading: boolean;
    autoCompleteResults?: IAutocompleteResults;
    setActiveHit?: (index: number) => void;
    setAutoCompleteActive?: (value: boolean) => void;

    contextComponent: JSX.Element;
}

interface IState {
    searchText: string;
}

export class SearchBar extends React.Component<IProps, IState> {
    static defaultProps = {
        autoCompleteResults: null,
        charsForAutocomplete: 1,
        searchButtonText: "Search",
        placeHolder: "",
    }

    constructor(props) {
        super(props);

        this.state = {
            searchText: this.props.searchText,
        }

        this.HasAutocomplete = this.props.autoCompleteResults != null;
    }

    HasAutocomplete: boolean;

    /// <summary>
    /// Intercepts special keys that handle autocomplete scrolling and selection
    /// </summary>
    onInputKeyDown = (e) => {
        const { autoCompleteResults, setActiveHit } = this.props;

        switch (e.keyCode) {
            //Up arrow
            //Move selected autocomplete result up one
            case 38: {
                e.preventDefault();
                if (autoCompleteResults.activeHit == -1) {
                    setActiveHit(autoCompleteResults.hits.length - 1);
                } else {
                    setActiveHit(autoCompleteResults.activeHit - 1);
                }
                break;
            }

            //Down arrow
            //Move selected autocomplete result down one
            case 40: {
                e.preventDefault();
                if (autoCompleteResults.activeHit == autoCompleteResults.hits.length - 1)
                    setActiveHit(-1);
                else
                    setActiveHit(autoCompleteResults.activeHit + 1);
                break;
            }

            //Enter key
            //If an autocomplete option is selected, change the search text to that, otherwise submit
            case 13: {
                let term = this.state.searchText;

                if (autoCompleteResults.activeHit > -1) {
                    term = this.props.autoCompleteResults.hits[this.props.autoCompleteResults.activeHit].query;
                    this.setSearchText(term);
                    this.props.setActiveHit(-1);
                }

                this.props.setAutoCompleteActive(false);
                this.props.onSearch(term);
            }
        }
    }

    setSearchText = (searchText: string) => {
        this.setState({ searchText });
    }

    onInputChange(value: string) {
        this.setSearchText(value);
        this.props.onChange(value);
    }

    AutocompleteResultClicked = (value: string) => {
        this.setSearchText(value);
        this.props.setActiveHit(-1);
        this.props.setAutoCompleteActive(false);
        this.props.onSearch(value);
    }

    onBlur = () => {
        if (!this.HasAutocomplete) {
            return;
        }

        if (this.props.autoCompleteResults.activeHit == -1) {
            this.props.setAutoCompleteActive(false);
        }
    }

    onFocus = () => {
        if (!this.HasAutocomplete) {
            return;
        }

        if (this.state.searchText.length >= this.props.charsForAutocomplete) {
            this.props.setAutoCompleteActive(true);
        }
    }

    handleSearchButtonClick = () => {
        this.props.onSearch(this.state.searchText);
    }

    renderAutocomplete = () => {
        const { autoCompleteResults } = this.props;

        if (!autoCompleteResults.isActive || this.state.searchText.length < 3 || autoCompleteResults.hits.length === 0) {
            return;
        }

        return (
            <Autocomplete
                autocompleteResults={this.props.autoCompleteResults}
                searchTerm={this.state.searchText}
                onResultClick={this.AutocompleteResultClicked}
                onResultActive={this.props.setActiveHit}
                onMouseLeave={() => this.props.setActiveHit(-1)}
            />
        );
    }

    render() {
        const { searchSuggestionText, searchSuggestion, loading, contextComponent } = this.props;

        return (
            <React.Fragment>
               
                    

                    <div className='adage-search-app-form-inner'>
                        <div className='adage-search-app-form-textbox'>
                            <Textbox
                                id={this.props.id}
                                onInput={(e) => { this.onInputChange(e.currentTarget.value) }}
                                onKeyDown={this.onInputKeyDown}
                                placeHolder={this.props.placeHolder}
                                onBlur={this.onBlur}
                                onFocus={this.onFocus}
                                value={this.state.searchText}
                            />

                            {this.renderAutocomplete()}
                        </div>

                        <button className="adage-search-app-form-button btn-primary" type='submit' onClick={this.handleSearchButtonClick}>
                            <span>{this.props.searchButtonText}</span>
                        </button>
                    </div>

               
            </React.Fragment>
        )
    }

}